export default class TemporaryWorkFeedbackController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/temporaryWorkFeedback/list', 'post', params, axiosOption, httpOption);
  }
  static listDict (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/temporaryWorkFeedback/listDict', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/temporaryWorkFeedback/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/temporaryWorkFeedback/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/temporaryWorkFeedback/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/temporaryWorkFeedback/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/temporaryWorkFeedback/delete', 'post', params, axiosOption, httpOption);
  }

  static assign (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/temporaryWorkFeedback/assign', 'post', params, axiosOption, httpOption);
  }
}
